module.exports = __webpack_public_path__ + "static/media/monitor.41fdd36c.png";